// extracted by mini-css-extract-plugin
export var actionButtons = "task-module--actionButtons--6a4c5";
export var detailSectionSize = "task-module--detailSectionSize--45cf8";
export var detailsImage = "task-module--detailsImage--1db95";
export var detailsSection = "task-module--detailsSection--2cf57";
export var greenFill = "task-module--greenFill--81e25";
export var headingContainer = "task-module--headingContainer--93257";
export var iconAndTitle = "task-module--iconAndTitle--ebc34";
export var iconLeftPadding = "task-module--iconLeftPadding--8706f";
export var iconTopPadding = "task-module--iconTopPadding--2d710";
export var itemDetails = "task-module--itemDetails--4070d";
export var itemDetailsParagraph = "task-module--itemDetailsParagraph--2050d";
export var itemImage = "task-module--itemImage--7a73d";
export var itemInfo = "task-module--itemInfo--4df8e";
export var itemsTabItemInfo = "task-module--itemsTabItemInfo--38efe";
export var orangeFill = "task-module--orangeFill--2f7ce";
export var outlineButton = "task-module--outlineButton--1a410";
export var placeholder = "task-module--placeholder--2d321";
export var redFill = "task-module--redFill--66629";
export var serialNumberIcon = "task-module--serialNumberIcon--902e9";
export var successButton = "task-module--successButton--93037";
export var task = "task-module--task--1e75b";
export var taskDetails = "task-module--taskDetails--62f58";
export var taskDetailsSmartAudit = "task-module--taskDetailsSmartAudit--19404";
export var taskDetailsSmartAuditContainer = "task-module--taskDetailsSmartAuditContainer--29e41";
export var taskHeaderContainer = "task-module--taskHeaderContainer--7c0cd";
export var tooltipSpacer = "task-module--tooltipSpacer--8ddf5";
export var width35 = "task-module--width-35--6718f";
export var width42 = "task-module--width-42--e1997";